import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 1,
        delay: 1.5,
        ease: 'power4.in'
      },
      scrollTrigger: {
        trigger: "#icon-download",
        start: "top center",
        end: "bottom center",
        markers: false,
        toggleActions: "play none play reset"
      }
    }).fromTo('.down-arrow', {
        duration: .3,
        x: 0,
        y: -10,
        opacity: 0,
      }, {
        x: 0,
        y: 0,
        opacity: 1,
      })
    });

 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.98 99.44" id="icon-download">
		<g fill="none" stroke="#001e5d" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4">
			<path d="M15.43 52.21V21.57m96.55 0v55.88L63.71 96.34l-19.2-7.52m35.84-55.31-16.64 6.27-48.28-18.21L63.71 2l48.27 19.57-16.27 6.14m-32 12.07v56.56m31.48-69.15L46.92 8.98"/>
			<path d="M95.19 27.19v19.54l-6.64-.34-7.53 5.79V33.74l-48.8-18.47M72.87 81.6l16.66-6.28V67l-16.66 6.28v8.32z"/>
			<circle cx="25.21" cy="74.23" r="23.21"/>
			<path className="down-arrow" d="M39.11 79.27v3.6a2.5 2.5 0 0 1-2.5 2.5h-22.8a2.5 2.5 0 0 1-2.5-2.5v-3.6m13.9-1.45-6.56-6.71m6.56 6.71 6.55-6.71m-6.55-10.98v17.69"/>
		</g>
	</svg>
 );
}